export default "__VITE_ASSET__e9e04851__"